"use client"
import { PhoneInput } from "@/components/ui/animated/phone-input/phone-input"
export function PhoneField({ label, onChange, ...props }: { id: string; label: string; value: string; onChange: (value: string) => void; disabled?: boolean; required?: boolean }) {
  return <PhoneInput {...props} label={label || "Phone number"} hideLabel onValueChange={onChange} defaultCountry="US" />
}
